import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"

import Modal from "../Modal/Modal"
import * as styles from "./Special.module.scss"

const SpecialItem = () => {
  const data = useStaticQuery(graphql`
    query {
      imageSpecialThumb: file(relativePath: { eq: "special_blackclover.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1000) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageSpecial1: file(relativePath: { eq: "special_blackclover_1.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1000) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageSpecial2: file(relativePath: { eq: "special_blackclover_2.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1000) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageSpecial3: file(relativePath: { eq: "special_blackclover_3.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1000) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
  const imageSpecialThumb = data.imageSpecialThumb.childImageSharp.fluid
  const imageSpecial1 = data.imageSpecial1.childImageSharp.fluid
  const imageSpecial2 = data.imageSpecial2.childImageSharp.fluid
  const imageSpecial3 = data.imageSpecial3.childImageSharp.fluid

  const [isOpen, setIsOpen] = useState(false)

  function handleOpen() {
    // Check body width & hide header
    const clientWidth = document.body.clientWidth
    // Add overflow:hidden & check scrollbar width & add padding-right to body & add modal element
    setTimeout(() => {
      document.body.classList.add("lock")
      const noScrollBarWidth = document.body.clientWidth
      const diff = noScrollBarWidth - clientWidth
      if (diff > 0) {
        document.body.style.paddingRight = diff + "px"
      }
      setIsOpen(true)
      // Add fadein animation
      setTimeout(() => {
        const modal = document.querySelector(".md__content")
        modal.classList.add("show")
        const bodyOverlay = document.querySelector(".md__overlay")
        bodyOverlay.style.cssText = "opacity: 1; visibility: visible"
      }, 100)
    }, 100)
  }

  return (
    <div className={`${styles.root} special`}>
      <button
        className={`${styles.special__item} special__item`}
        onClick={handleOpen}
      >
        <figure role="figure">
          <div className={styles.overlay}></div>
          <Img fluid={imageSpecialThumb} alt="" />
          <figcaption>
            <span>
              Black Clover
              <br />
              1.2 Million views{" "}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
                <path d="M8.83,6.53A.84.84,0,0,0,8.81,5a.81.81,0,0,0,.3-.63.85.85,0,0,0-.84-.84H6.37a2.49,2.49,0,0,0,.28-1.4C6.6,1.57,6.15.62,5.45.57c-.53,0-.64.16-.64.7,0,0,0,.53-.11.86A2.51,2.51,0,0,1,3.59,3.57c-.93.66-1.25.77-1.26,1.21,0,.92,0,3,0,3.65s1.55,1,2.38,1H7.58c.46,0,1.09-.22,1.09-.84A.81.81,0,0,0,8.43,8a.84.84,0,0,0,.71-.83A.81.81,0,0,0,8.83,6.53Z" />
                <path d="M1.79,4.5h-1a.36.36,0,0,0-.36.36V8.54a.35.35,0,0,0,.36.35h1a.35.35,0,0,0,.35-.35V4.86A.36.36,0,0,0,1.79,4.5Z" />
              </svg>
              Motion Graphics
              <br />
              <span className={styles.special__item__casestudy__left}>[</span>
              Case Study
              <span className={styles.special__item__casestudy__right}>]</span>
            </span>
          </figcaption>
        </figure>
      </button>

      <Modal isOpen={isOpen} setIsOpen={setIsOpen} contentID={"special"}>
        <div className={styles.modal}>
          <div>
            <div className={styles.modal__embed}>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/kcpSP31USNw"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className={styles.modal__description}>
              <div
                className={`${styles.modal__container} ${styles.container1}`}
              >
                <div>
                  <h3 className={styles.modal__title}>
                    "Black Clover" Movie announcement PV
                  </h3>
                  <div>
                    Fumiro directed the motion graphics for the announcement PV
                    of the highly anticipated "Black Clover" movie.
                  </div>
                  <div>
                    The promotional video garnered significant attention,
                    accumulating 1.2 million views and over 28,000 likes on
                    YouTube, and was featured across more than 50 media outlets.
                  </div>
                </div>

                <div>
                  <Img fluid={imageSpecial1} alt="" />
                </div>
              </div>

              <div>
                Based on the popular manga from JUMP COMIC, "Black Clover" has
                achieved global recognition, securing the top-viewed spot in 87
                countries on Crunchyroll.
              </div>
              <div>
                Given the intricate nature of this long-running series, the
                project required meticulous handling of delicate source
                materials and assets. Fumiro proactively introduced technical
                efficiencies, proposing camera angles and generating
                pre-visualizations in Maya from the initial planning phase. This
                approach streamlined the design of key visuals, facilitated a
                smooth client approval workflow, and ensured animation
                confirmation was managed efficiently.
              </div>
              <div>
                Specifically, he imported approved FBX cameras and motion
                designs from the pre-visualization phase directly into Flame for
                final layout and finishing.
              </div>
              <div>
                <Img fluid={imageSpecial2} alt="" />
              </div>

              <div
                className={`${styles.modal__container} ${styles.container2}`}
              >
                <div>
                  This coherent integration of design, animation, and finishing
                  processes, starting with the early presentation and client
                  approval stages, significantly enhanced the quality of the
                  final deliverable. The project serves as a clear demonstration
                  of how Fumiro leverages his diverse expertise to meet high
                  client standards while consistently delivering superior
                  production quality.
                </div>
                <div>
                  <Img fluid={imageSpecial3} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default SpecialItem
